export const name = 'components' as const

export const ComponentPropsExtenderSymbol = Symbol('ComponentPropsExtender')
export const ComponentDriverSymbol = Symbol('ComponentDriver')
export const ComponentDriverProviderSymbol = Symbol('ComponentDriverProvider')
export const BaseTraitSymbol = Symbol('BaseTrait')
export const ComponentWillMountSymbol = Symbol('ComponentWillMount')
export const ComponentsStoreSymbol = Symbol('ComponentsStore')
